import React from 'react';
export function FinalCTA() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    element?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-navy text-white py-12 px-6" data-id="element-100">
      <div className="max-w-md mx-auto text-center space-y-6" data-id="element-101">
        <h2 className="text-2xl font-bold leading-tight" data-id="element-102">
          A partir de mañana, tu clínica funciona con un sistema profesional. 🐾
        </h2>

        <div className="space-y-3 pt-4" data-id="element-103">
          <button onClick={() => scrollToSection('precios')} className="w-full bg-teal text-white h-14 rounded-xl font-bold text-lg hover:bg-teal/90 transition-colors" data-id="element-104">
            🐾 Quiero el Kit Veterinario Elite
          </button>

          <button onClick={() => scrollToSection('precios')} className="w-full border-2 border-white text-white h-14 rounded-xl font-semibold hover:bg-white/10 transition-colors" data-id="element-105">
            🚀 Quiero el Kit Elite PRO
          </button>
        </div>

        <div className="text-sm opacity-80 pt-4 space-x-2" data-id="element-106">
          <span data-id="element-107">✅ Garantía 7 días</span>
          <span data-id="element-108">·</span>
          <span data-id="element-109">🔒 Pago seguro</span>
          <span data-id="element-110">·</span>
          <span data-id="element-111">⚡ Acceso inmediata</span>
        </div>
      </div>
    </section>;
}